import { EventListeners, MinzeElement, Reactive } from "minze";
import { Locale } from "../../modules/locale";
import { SquidexTextLabels } from "../../modules/squidex/labels";

export interface TjCookiesPopup {}

Locale.getInstance().registerKeySet("fr", "cookiesPopup", {
  description:
    "Tel-jeunes souhaite utiliser des cookies ou autres traceurs et traiter vos données personnelles (données de navigation, données renseignées dans votre compte et/ou lors de l'utilisation des services, etc.) pour mesurer vos interactions avec notre site web dans le but d’améliorer votre expérience. Pour en savoir plus, consultez nos Conditions d'utilisation et vie privée. Vous pouvez tout autoriser ou refuser une partie de ces traitements de données à l'exception des cookies et/ou traceurs nécessaires au fonctionnement de ce site Web.",
  more: "En savoir plus",
  deny: "Refuser les cookies",
  grant: "Accepter les cookies",
  privacyPolicyUrl: "/fr/a-propos/conditions-d-utilisation-et-vie-privee",
});

Locale.getInstance().registerKeySet("en", "cookiesPopup", {
  description:
    "Tel-jeunes wishes to use cookies or other tracking devices and process your personal data (browsing data, data entered in your account and/or when using services, etc.) to measure your interactions with our website in order to improve your experience. To find out more, see our Terms of Use and Privacy Policy. You may authorize or refuse all or part of this data processing, with the exception of cookies and/or tracers necessary for the operation of this website.",
  more: "More information",
  deny: "Reject cookies",
  grant: "Accept cookies",
  privacyPolicyUrl: "/en/about/terms-and-conditions-and-privacy",
});

export class TjCookiesPopup extends MinzeElement {
  reactive: Reactive = [["visible", true]];
  
  isMobile = window.matchMedia("(max-width: 768px)").matches;
  setConsent(granted: boolean = false) {
    const consent = {
      necessary: granted,
      marketing: granted,
      analytics: granted,
      preferences: granted,
    };
    const consentMode = {
      functionality_storage: consent.necessary ? "granted" : "denied",
      security_storage: consent.necessary ? "granted" : "denied",
      "ad storage": consent.marketing ? "granted" : "denied",
      analytics_storage: consent.analytics ? "granted" : "denied",
      personalization: consent.preferences ? "granted" : "denied",
    };
    localStorage.setItem("tjConsentMode", JSON.stringify(consentMode));
    this.visible = false;
    // @ts-ignore
    gtag("consent", "update", consent);
  }
  html = () =>
    localStorage.getItem("tjConsentMode") === null && this.visible
      ? `
    <div class="cookies-popup">
      <tj-box class="cookies-popup-content">
        <tj-text color="#133762" line-height="150%">
          ${SquidexTextLabels.getKey("cookiesPopup.description")}
        </tj-text>
        <tj-box
          display="flex"
          justifyContent="space-between"
          flexDirection="${this.isMobile ? "column-reverse" : "row"}"
          mt="24px"
        >
          <a href="${SquidexTextLabels.getKey("cookiesPopup.privacyPolicyUrl")}" class="more-link">
            ${SquidexTextLabels.getKey("cookiesPopup.more")}
          </a>
          <tj-box
            display="flex"
            columnGap="${this.isMobile ? "8px" : "24px"}"
            rowGap="${this.isMobile ? "8px" : "24px"}"
            flexDirection="${this.isMobile ? "column" : "row"}"
          >
            <tj-button id="decline" size="small" bg="white" textColor="#068FC3" border="1px solid #068FC3"
            class="cookies-popup-decline-button"
            >
              ${SquidexTextLabels.getKey("cookiesPopup.deny")}
            </tj-button>
            <tj-button id="accept" size="small"
            class="cookies-popup-accept-button"
            >
              ${SquidexTextLabels.getKey("cookiesPopup.grant")}
            </tj-button>
          </tj-box>
        </tj-box>
      </tj-box>
      <tj-cookie-icon></tj-cookie-icon>
    </div>
  `
      : "";

  css = () => `
     @keyframes slide-up {
      0% {
        transform: translateY(110vh);
      }
      100% {
        transform: translateY(0vh);
      }
    }
    .cookies-popup {
      position: fixed;
      z-index: 1001;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 24px;
      display: flex;
      justify-content: center;
      background: white;
      box-shadow: 0px -3px 25px 0px #0000001c;
      transform: translateY(110vh);
      animation: slide-up 1s forwards;
    }
    .cookies-popup > .cookies-popup-content {
      max-width: 1184px;
    }
    tj-cookie-icon {
      position: absolute;
      bottom: -5px;
      left: 21px;
      z-index: -1;
    }
    .more-link {
      color: #133762;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
      text-decoration-line: underline;
      padding: 8px 0;
      text-align: center;
    }
    @media (max-width: 768px) {
      .cookies-popup {
        padding: 16px;
      }
      tj-cookie-icon {
        bottom: -15px;
        left: 16px;
      }
    }
  `;
  eventListeners: EventListeners = [
    ["#decline", "click", () => this.setConsent(false)],
    ["#accept", "click", () => this.setConsent(true)],
  ];
}
